import React, {
  useState, useContext,
  useEffect, useRef,
} from "react";
import { XLg, List } from "react-bootstrap-icons";
import {
  header, top, body,
  head, opened,
  logo, closeIcon,
  contact, login, left, right,
  tabContent, middle,
  active, desktopHeader, inviteFriends,
  cartContainer, cartCount, cartIcon, badge, newLogo,
  fadeInvisible, fadeIn, trustedShop
} from "../style.mod.scss";
import DesktopBody from "./body";
import GlobalContext from "services/global-context";
import CartIcon from "assets/svgs/cart-icon.svg";
import Logo from "assets/images/olavson.svg";
import Link from "components/link";
import locale from "locales";
import RebrandingNotice from "src/components/rebranding-notice";
import QuestionsMarkIcon from "src/assets/svgs/HelpMeBadge.svg";
import { trackMenuClick } from "helpers/analytics";
import trustbadge from "assets/images/trustbadge.png";

const Header = ({ headerData, contactUrl, rebranding }) => {
  const _headerRef = useRef(null);
  const globalContext = useContext(GlobalContext);
  const [open, setOpen] = useState(false);
  const [bodyData, setBodyData] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [visible, setVisible] = useState(false);
  const openClass = () => open ? opened : "";
  const activeTabClass = (tab) => activeTab === tab ? active : "";
  const toggleMenu = (isOpen = false) => {
    setOpen(isOpen);
    !isOpen && setActiveTab(null);
  };

  let cartTotalQty;

  if (typeof window === "undefined")
    cartTotalQty = 0;
  else
    cartTotalQty = localStorage.getItem("cartTotalQty") || 0;

  useEffect(() => {
    _headerRef.current.addEventListener("mouseleave", () => toggleMenu(false));
    const timer = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const changeTab = (newOpen, newData, tab, wTimeout = true) => {
    setTimeout(() => {
      setBodyData(newData);
      const sameTab = (tab === activeTab);

      let openChanged = open !== newOpen;
      let tabState = !sameTab ? tab : activeTab;

      if (openChanged) setOpen(newOpen);
      setActiveTab(tabState);
    }, wTimeout ? 200 : 0);
  };

  const CloseIcon = (props) => (
    <a
      className={`${closeIcon} ${openClass()}`}
      onClick={props.onClick}>
      {open ? <XLg /> : <List />}
    </a>
  );

  const isDirect = (lnk) => lnk._type === "directLink";

  const DesktopMenu = (props) => (
    <div className={props.className} onBlur={toggleMenu}>
      {
        headerData?.link?.map((tab) => (
          isDirect(tab) ?
            <Link key={tab._key} className={`${activeTabClass(tab._key)}`} to={tab?.url} style={{ color: tab?.textColor && tab?.textColor?.hex }}
              onClick={() => trackMenuClick(tab)}
              onMouseEnter={() => changeTab(false, tab, tab._key, false)}>
              {tab.title}{tab?.badge
                && <span className={badge}>{locale.products.new}</span>}</Link>
            : <Link
              key={tab._key}
              to={tab.url}
              onClick={() => trackMenuClick(tab)}
              className={`${activeTabClass(tab._key)}`}
              onMouseEnter={() => changeTab(true, tab, tab._key, false)}
              style={{ color: tab?.textColor && tab?.textColor?.hex }}
            >
              {tab.title} {tab?.badge && <span className={badge}>{locale.products.new}</span>}
            </Link>
        ))
      }
    </div>
  );

  const [openNotice, setOpenNotice] = useState(false);

  const hideModal = () => setOpenNotice(false);

  return (
    <div className={`${header} ${desktopHeader}`} ref={_headerRef}>
      <div className={head}>
        <div className={top}>
          <div className={left}>
            <CloseIcon onClick={() => toggleMenu(!open)} />
            {rebranding?.enableRebranding ? <div className={newLogo}><Link to="/" ><img src={Logo} className={logo} alt="Olavson Logo" /></Link><QuestionsMarkIcon onMouseEnter={() => setOpenNotice(true)}
              onMouseLeave={() => setOpenNotice(true)} />  </div> :
              <Link to="/" onClick={() => trackMenuClick({
                url: "/", title: "Logo"
              })}><img src={Logo} className={logo} alt="Olavson Logo" /></Link>}

          </div>
        </div>
        <div className={top} >
          <DesktopMenu className={middle} />
        </div>
        <div className={`${right} ${visible ? fadeInvisible : fadeIn}`}>
          <img src={trustbadge} alt="Trusted Shops Logo" className={trustedShop} />
          {!globalContext?.disableAccounts &&
            <Link to="/haendlersuche" className={login}><span>{locale.retailers.storeLocator}</span></Link>}
          {(!globalContext?.disableAccounts && globalContext?.currentCustomer !== null) && <Link to="/account/invite-friends" className={inviteFriends} onClick={() => trackMenuClick({
            url: "/account/invite-friends", title: locale.header.inviteFriends
          })}><span>{locale.header.inviteFriends}</span></Link>}
          {(!globalContext?.disableAccounts && globalContext?.currentCustomer === null) && <Link to="/invite-friends" className={login} onClick={() => trackMenuClick({
            url: "/invite-friends", title: locale.header.inviteFriends
          })}><span>{locale.header.inviteFriends}</span></Link>}
          <Link to={contactUrl} className={contact} onClick={() => trackMenuClick({
            url: contactUrl, title: locale.header.contact
          })}>{locale.header.contact}</Link>
          <div className={cartContainer} onClick={globalContext?.toggleCart}>
            <div className={cartIcon}><CartIcon /></div>
            {cartTotalQty !== null && parseInt(cartTotalQty) !== 0 && <div className={cartCount}>{cartTotalQty}</div>}
          </div>
        </div>
      </div>
      <div className={`${body} ${openClass()}`}>
        <div className={tabContent}>
          <DesktopBody data={bodyData} />
          <CloseIcon onClick={() => toggleMenu(false)} />
        </div>
      </div>
      {openNotice &&
        <RebrandingNotice rebranding={rebranding} openNotice={openNotice} hideModal={hideModal} />}
    </div>
  );
};

export default Header;